import { type AddToCartActionStatus } from "@/app/actions/cart";

export const ADD_TO_CART_ERROR_MESSAGES: Record<AddToCartActionStatus, string> =
	{
		"network-error":
			"Something went wrong on our end. Please try again in a moment.",
		"out-of-stock": "Sorry, this item is out of stock.",
		"session-expired":
			"Your session has expired. Please refresh the page and try again.",
		"purchase-restricted":
			"This item can't be added to your cart due to purchase restrictions.",
		unknown: "We couldn't add this item to your cart. Please try again."
	};

export function getAddToCartErrorMessage(
	status: AddToCartActionStatus
): string {
	return ADD_TO_CART_ERROR_MESSAGES[status];
}
